import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'User added a comment',
  name: 'Added a comment',
  params: [
    {
      description: 'The comment that was added',
      name: 'comment',
      required: true,
      type: 'string',
    },
    {
      description: 'Whether the comment started a discussion',
      name: 'startedDiscussion',
      required: true,
      type: 'boolean',
    },
    {
      description: 'The clip ID that the comment was added to',
      name: 'clipId',
      required: true,
      type: 'string',
    },
    {
      description: 'The board ID that the comment was added to',
      name: 'boardId',
      required: false,
      type: 'string',
    },
    {
      description: 'Whether the comment was public',
      name: 'public',
      required: false,
      type: 'boolean',
    },
    {
      description: 'The location where the user added a comment',
      name: 'location',
      required: true,
      type: 'enum',
      values: ['all-media', 'bookmarks', 'board', 'public-board', 'asset-page'],
    },
    {
      description: 'Whether the comment has a timestamp',
      name: 'has_timestamp',
      required: false,
      type: 'boolean',
    },
    {
      description: 'Whether the comment has an annotation',
      name: 'has_annotation',
      required: false,
      type: 'boolean',
    },
    {
      description: 'The type of annotation',
      name: 'annotationType',
      required: false,
      type: 'enum',
      values: ['area', 'point', 'pencil', 'standalone'],
    },
    {
      description: 'The type of asset',
      name: 'assetType',
      required: false,
      type: 'enum',
      values: ['animated', 'audio', 'livePhoto', 'nonMedia', 'photo', 'video'],
    },
  ],
};

export default META;
